export const Spacing = { 
  s01: "0.125rem", //2px
  s02: "0.25rem", //4px
  s03: "0.5rem", //8px
  s04: "0.75rem", //12px
  s05: "1rem",//16px
  s06: "1.25rem", //20px
  s07: "1.5rem",//24px
  s08: "2rem",//32px
  s09: "2.5rem", //40px
  s10: "3rem",//48px
  s11: "3.5rem", //56px
  s12: "4rem",//64px
  s13: "4.5rem",//72px
  s14: "5rem", //80px
  s15: "6rem", //96px
  s16: "7rem", //112px
  s17: "8rem", //128px
  s18: "10rem", //160px
  s19: "11rem", //176px
  s20: "12rem", //192px


  videowall: {
    xxxs: "calc(0.105 * var(--vw, 1vw))", //design canvas 3840px → 4px
    xxs:  "calc(0.209 * var(--vw, 1vw))", //design canvas 3840px → 8px
    xs:   "calc(0.313 * var(--vw, 1vw))", //design canvas 3840px → 12px
    sm:   "calc(0.417 * var(--vw, 1vw))", //design canvas 3840px → 16px
    md:   "calc(0.547 * var(--vw, 1vw))", //design canvas 3840px → 21px
    lg:   "calc(0.678 * var(--vw, 1vw))", //design canvas 3840px → 26px
    xl:   "calc(0.756 * var(--vw, 1vw))", //design canvas 3840px → 29px
    xxl:  "calc(0.834 * var(--vw, 1vw))", //design canvas 3840px → 32px
    xxxl: "calc(0.939 * var(--vw, 1vw))"  //design canvas 3840px → 36px
  }
};